import React from "react";
import { makeStyles } from "@material-ui/core/styles";

import * as layouts from "../../Layouts/index";

import homedata from "../../data/Gallery";
import NavAndFooter from "../Common/NavAndFooterContainer";
import LoadingComponet from "../../components/Loading/LoadingComponet";
import GetPageData from "../../hooks/GetPageData";
import { useSelector } from "react-redux";

const useStyles = makeStyles((theme) => ({
  root: {
    width: "100%",
    display: "flex",
    justifyContent: "center",
    [theme.breakpoints.down("md")]: {
      // backgroundColor: "white",
    },
  },
}));

const FormsPage = () => {
  const classes = useStyles();
  const gramId = useSelector((state) => state.util.currentGramId);

  const { ready, data, error } = GetPageData(`gallery/${gramId}`);

  return ready && data ? (
    <div className={classes.root}>
      {data?.data?.map((data, index) => {
        const Layout = layouts[data?.layout];
        return <Layout key={index} data={data} />;
      })}
    </div>
  ) : (
    <div>
      <LoadingComponet />
    </div>
  );
};
export default FormsPage;
